import { FormPagePropertyItemPasswordHash } from 'backend';
import { RE_ENTER_PROPERTY_ID_PREFIX } from 'reEnter';
import { FormPageInputData, PASSWORD_HASH_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '../getPropertyItemElements';

export const getPasswordHashInputValue = (
  propertyItem: FormPagePropertyItemPasswordHash,
  propertyItemElement: PropertyItemElement,
): FormPageInputData => {
  switch (propertyItem.inputFormat.inputType) {
    case PASSWORD_HASH_PROPERTY_INPUT_TYPE.text: {
      const passwordElement = propertyItemElement.password;
      if (!(passwordElement instanceof HTMLInputElement)) {
        return {};
      }
      const passwordValue = passwordElement.value;

      const reEnterElement = propertyItemElement.reEnter;
      if (
        !propertyItem.reEnter ||
        !(reEnterElement instanceof HTMLInputElement)
      ) {
        return {
          [propertyItem.propertyId]: {
            inputItemType: 'passwordHashText',
            password: passwordValue,
          },
        };
      }
      return {
        [propertyItem.propertyId]: {
          inputItemType: 'passwordHashText',
          password: passwordValue,
        },
        [`${RE_ENTER_PROPERTY_ID_PREFIX}${propertyItem.propertyId}`]: {
          inputItemType: 'passwordHashText',
          password: reEnterElement.value,
        },
      };
    }
  }
};
